import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface LoginState {
  user: Record<string, any>; // Sostituisce il problematico "{}"
  eventId: string;
  namePharmacy: string;
  eventHash: string;
  eventUuid: string;
  urlDownloadDocument: string;
  urlDownloadAutocertificazione: string;
  urlDownloadReport: string;
  urlDownloadConditionsUse: string;
  tagManagerBackoffice: any; // Evita che TypeScript lo blocchi solo su "null"
  rangEvent: Record<string, any>;
  saml: boolean;
}

const initialState: LoginState = {
  user: {},
  eventId: "",
  namePharmacy: "",
  eventHash: "",
  eventUuid: "",
  urlDownloadDocument: "",
  urlDownloadAutocertificazione: "",
  urlDownloadReport: "",
  urlDownloadConditionsUse: "",
  tagManagerBackoffice: null,
  rangEvent: {},
  saml: false,
};

export const initLoginData =
  (checkNavigationResponse: any) => async (dispatch: any) => {
    dispatch(updateEventId(checkNavigationResponse.eventId));
    dispatch(updateNamePharmacy(checkNavigationResponse.namePharmacy));
    dispatch(updateEventHash(checkNavigationResponse.eventHash));
    dispatch(updateEventUuid(checkNavigationResponse.eventUuid));
    dispatch(updateRangEvent(checkNavigationResponse.rangEvent));
    dispatch(
      updateUrlDownloadDocument(checkNavigationResponse.urlDownloadDocument)
    );
    dispatch(
      updateUrlAutocertificazione(
        checkNavigationResponse.urlDownloadAutocertificazione
      )
    );
    dispatch(updateUrlReport(checkNavigationResponse.urlDownloadReport));
    dispatch(
      updateUrlDownloadConditionsUse(checkNavigationResponse.urlDownloadConditionsUse)
    );
    dispatch(
      updateTagManagerBackoffice(checkNavigationResponse.tagManagerBackoffice)
    );
  };

const loginReducer = createSlice({
  name: "login",
  initialState,
  reducers: {
    deleteUser(state) {
      state.user = {};
    },
    deleteEvent(state) {
      state.eventId = "";
    },
    deleteNamePharmacy(state) {
      state.namePharmacy = "";
    },
    deleteRangEvent(state) {
      state.rangEvent = {};
    },
    updateUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
    updateEventHash(state, action: PayloadAction<any>) {
      state.eventHash = action.payload;
    },
    updateEventUuid(state, action: PayloadAction<any>) {
      state.eventUuid = action.payload;
    },
    updateRangEvent(state, action: PayloadAction<any>) {
      state.rangEvent = action.payload;
    },
    updateEventId(state, action: PayloadAction<any>) {
      state.eventId = action.payload;
    },
    updateUrlDownloadDocument(state, action: PayloadAction<any>) {
      state.urlDownloadDocument = action.payload;
    },
    updateUrlAutocertificazione(state, action: PayloadAction<any>) {
      state.urlDownloadAutocertificazione = action.payload;
    },
    updateUrlReport(state, action: PayloadAction<any>) {
      state.urlDownloadReport = action.payload;
    },
    updateUrlDownloadConditionsUse(state, action: PayloadAction<any>) {
      state.urlDownloadConditionsUse = action.payload;
    },
    updateNamePharmacy(state, action: PayloadAction<any>) {
      state.namePharmacy = action.payload;
    },
    updateTagManagerBackoffice(state, action: PayloadAction<any>) {
      state.tagManagerBackoffice = action.payload;
    },
    updateSaml(state, action: PayloadAction<boolean>) {
      state.saml = action.payload;
    },

  },
});

export const {
  deleteUser,
  updateUser,
  deleteEvent,
  updateEventId,
  updateNamePharmacy,
  updateEventHash,
  updateEventUuid,
  deleteNamePharmacy,
  updateTagManagerBackoffice,
  updateSaml,
  deleteRangEvent,
  updateRangEvent,
  updateUrlDownloadDocument,
  updateUrlAutocertificazione,
  updateUrlReport,
  updateUrlDownloadConditionsUse,
} = loginReducer.actions;

export default loginReducer.reducer;
